// -------------- BASICS --------------
const
    page = (name) => { let result = true; name.split(" ").forEach(name => { if (!document.body.classList.contains(name)) result = false; }); return result; },
    pageContains = (el) => { return !!(document.querySelector(el)) },
    mobile = () => { return window.innerWidth < mobileBreakPoint; },
    touch = () => { return document.body.classList.contains("touch-device") },
    getRem = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue("font-size").replace("px", "")),
    addTouchClassIfNecessary = (() => { if (window.matchMedia("(pointer: coarse)").matches) document.body.classList.add("touch-device"); })(),
    dontSaveOnMetaS = (() => { let m = 0, s = 0; window.addEventListener("keydown", e => { if (e.key === "Meta") m = 1; if (e.key === "s" && m) (s = 1) && e.preventDefault(); }); window.addEventListener("keyup", e => { if (e.key === "Meta") m = 0; if (e.key === "s") s = 0; }); })(),
    setEscapeToExitMenu = (() => { window.addEventListener("keydown", (e) => { if (e.key == "Escape" && document.querySelector("input.burger").checked) document.querySelector("input.burger").checked = false }); })();

// -------------- STATEMENTS --------------
const
    mobileBreakPoint = 768,
    productionUrl = "activemodesty.com";
let rem = getRem();
window.addEventListener("resize", () => rem = getRem());
if (Shopify.designMode) document.body.classList.add("shopify-design-mode");

// -------------- FUNCTIONS --------------
function debounce(callback, delay) {
    let timerId;
    return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            callback.apply(this, args);
        }, delay);
    };
}
function setupAnchorAttributes() {
    const as = document.querySelectorAll("a");
    as.forEach(a => {
        if (a.href.includes("https://") && (!a.href.includes(productionUrl) && (!a.href.includes(".myshopify.com")) && (!a.href.includes("127.0.0.1:1313")) && !a.href.includes("localhost:1313")) || a.href.includes("pdf")) a.setAttribute("target", "_blank");
    });
}

function setOnlyRunInViewObservers() {
    const onlyRunWhenInViewObjects = document.querySelectorAll(".run-in-view");
    if (!!window.IntersectionObserver) {
        const options = {
            rootMargin: "0px 0px 0px 0px",
            threshold: 0,
        };
        let observer = new IntersectionObserver(entries => entries.forEach(entry => {
            entry.target.dataset.active = entry.isIntersecting;
        }), options);

        onlyRunWhenInViewObjects.forEach(object => {
            object.dataset.active = "false";
            observer.observe(object);
        });
    }
}

function setOnlyRunInViewOnceObservers() {
    const onlyRunWhenInViewObjects = document.querySelectorAll(".activate");
    if (!!window.IntersectionObserver) {
        const options = {
            rootMargin: "0px 0px 0px 0px",
            threshold: 0.1,
        };
        let observer = new IntersectionObserver(entries => entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.remove("activate")
                    observer.unobserve(entry.target);
                }, 125);
            }
        }), options);
        onlyRunWhenInViewObjects.forEach(object => observer.observe(object));
    }
}

function scrollFunction() {
    const
        header = document.querySelector("header"),
        threshold = 50;

    if (!header) return;
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update);
    window.addEventListener("load", update);

    function update() {
        header.dataset.scrolled = window.scrollY > threshold;
    }
}


function setupFilteredSection() {
    const sections = document.querySelectorAll("section.filtered-collections");

    sections.forEach(section => {
        const
            buttons = section.querySelectorAll("fieldset button"),
            lists = section.querySelectorAll(".odf-list");
        buttons.forEach(button => {
            button.addEventListener("click", () => filter(button));
        });

        function filter(targetButton) {
            buttons.forEach(button => button.dataset.active = button == targetButton);
            lists.forEach(list => list.ariaHidden = list.dataset.for != targetButton.dataset.filter);
        }
    })
}

function setupGrabToScrollers() {
    const
        scrollers = document.querySelectorAll(".grab-to-scroll");

    scrollers.forEach(scroller => {
        let
            isDown = false,
            startX = 0,
            scrollLeft = 0;

        scroller.addEventListener("mousedown", mousedown);
        scroller.addEventListener("mousemove", mousemove);
        window.addEventListener("mouseup", mouseup);

        function mousedown(e) {
            isDown = true;
            document.body.dataset.scrolling = true;
            startX = e.pageX - scroller.offsetLeft;
            scrollLeft = scroller.scrollLeft;
        }

        function mousemove(e) {
            if (!isDown) return;
            e.preventDefault();
            const
                x = e.pageX - scroller.offsetLeft,
                walk = x - startX;
            scroller.scrollLeft = scrollLeft - walk;
        }

        function mouseup() {
            isDown = false;
            document.body.dataset.scrolling = false;
        }
    });
}


function setupFakeScrollbars() {
    const
        uls = document.querySelectorAll("section.has-scrollbar .odf-overflower"),
        scrollbars = document.querySelectorAll("section.has-scrollbar .scrollbar"),
        getWidth = (ul) => ul.offsetWidth / ul.scrollWidth,
        getLeft = (ul) => ul.scrollLeft / ul.scrollWidth;

    window.addEventListener("resize", resize);
    window.addEventListener("load", resize);
    resize();

    uls.forEach(ul => ul.addEventListener("scroll", () => updateFakeScrollBar(ul)));
    scrollbars.forEach(scrollbar => {
        const
            overflower = scrollbar.closest("section").querySelector(".odf-overflower");
        let
            baseline = overflower.scrollLeft,
            delta = undefined,
            start = undefined;

        scrollbar.addEventListener("mousedown", mousedown);
        function mousedown(e) {
            document.body.dataset.scrolling = true;
            start = e.clientX
            window.addEventListener("mouseup", mouseup);
            window.addEventListener("mousemove", mousemove);
        }
        function mousemove(e) {
            delta = e.clientX - start;
            const
                amountOfScrollbarMoved = (delta / scrollbar.offsetWidth),
                adjustedMove = overflower.scrollWidth * amountOfScrollbarMoved;
            movebar(baseline + adjustedMove)
        }
        function mouseup() {
            start = undefined;
            delta = undefined;
            snapToClosestLeft();
            baseline = overflower.scrollLeft;
            document.body.dataset.scrolling = false;
            window.removeEventListener("mouseup", mouseup);
            window.removeEventListener("mousemove", mousemove);
        }

        function snapToClosestLeft() {
            const li = findClosestChild(overflower.firstElementChild, overflower.scrollLeft);
            overflower.scrollTo(li.offsetLeft, 0);
        }

        function findClosestChild(ul, targetLeft) {
            return Array.from(ul.children).reduce((closest, child) =>
                Math.abs(child.offsetLeft - targetLeft) < Math.abs(closest.offsetLeft - targetLeft)
                    ? child
                    : closest
            );
        }

        function movebar(delta) {
            overflower.scrollTo(delta, 0)
        }
    });

    function resize() {
        uls.forEach(ul => updateFakeScrollBar(ul));
    }

    function updateFakeScrollBar(ul) {
        const
            width = getWidth(ul),
            left = getLeft(ul);

        ul.parentNode.parentNode.style.setProperty("--w", width * 100 + "%");
        ul.parentNode.parentNode.style.setProperty("--l", left * 100 + "%");
        ul.closest("section").dataset.showScrollbar = width < 1;
    }
}

function setupOverflowerButtons() {
    const overflowers = document.querySelectorAll(".has-overflower.has-buttons");
    overflowers.forEach(div => {
        const
            slider = div.querySelector(".odf-overflower"),
            buttons = div.querySelectorAll("button[data-dir]");

        buttons.forEach(button => button.addEventListener("click", () => scroll(parseInt(button.dataset.dir))));
        slider.addEventListener("scroll", update);
        window.addEventListener("load", update);
        update();

        function update() {
            slider.dataset.left = slider.scrollLeft == 0;
            slider.dataset.right = slider.scrollLeft == slider.scrollWidth - slider.offsetWidth;
        }

        function scroll(dir) {
            slider.scrollBy(slider.querySelector("ul[aria-hidden=false] li").offsetWidth * 2 * dir, 0);
        }
    })
}

function setupShowTheLook() {
    const sections = document.querySelectorAll("section.shop-the-look");
    sections.forEach(section => {
        const
            looksDiv = section.querySelector(".looks"),
            parentButtons = section.querySelectorAll(".figures > .buttons button"),
            indicators = section.querySelectorAll(`.controls button.indicator`),
            switchButtons = section.querySelectorAll(`.controls button[data-dir]`),
            viewProductButton = section.querySelector("a.btn.large"),
            looks = [...section.querySelectorAll("figure")].map(d => {
                const linkedProductList = section.querySelector(`ul[data-look='${d.dataset.look}']`)
                return {
                    figure: d,
                    floaterButtons: d.querySelectorAll("button"),
                    list: linkedProductList,
                    products: linkedProductList.querySelectorAll(`.productcard`),
                }
            });
        let
            currentLookIndex = 0,
            currentProductIndex = 0,
            currentLook = looks[currentLookIndex];

        setLook();
        looks.forEach(lookObj => {
            lookObj.floaterButtons.forEach((button, i) => button.addEventListener("click", () => setLookToProduct(i)))
            lookObj.list.addEventListener("scroll", () => setNewIndexOnScroll(lookObj));
        });
        indicators.forEach((button, i) => button.addEventListener("click", () => setLookToProduct(i)));
        switchButtons.forEach(button => button.addEventListener("click", () => next(button)));
        parentButtons.forEach(button => button.addEventListener("click", () => nextLook(button)));

        function nextLook(button) {
            const
                amountOfLooks = looks.length;
            dir = parseInt(button.dataset.dir);

            currentLookIndex += dir;
            if (currentLookIndex >= amountOfLooks) currentLookIndex = 0;
            else if (currentLookIndex < 0) currentLookIndex = amountOfLooks - 1;
            setLook();
        }

        function setLook() {
            looksDiv.style.setProperty("--look", currentLookIndex);
            currentLook = looks[currentLookIndex];
            setLookToProduct(currentProductIndex)
        }

        function next(button) {
            const
                amountOfProducts = currentLook.floaterButtons.length,
                dir = parseInt(button.dataset.dir);

            currentProductIndex += dir;
            if (currentProductIndex >= amountOfProducts) currentProductIndex = 0;
            else if (currentProductIndex < 0) currentProductIndex = amountOfProducts - 1;
            setLookToProduct(currentProductIndex);
        }

        function updateIndicators() {
            const amountOfProducts = currentLook.floaterButtons.length;
            indicators.forEach((button, i) => {
                button.dataset.active = currentLook.floaterButtons[i]?.classList.contains("active");
                button.ariaHidden = i >= amountOfProducts
            });
        }

        function setNewIndexOnScroll({ list, products }) {
            const closest = getClosestOnScroll(list, products);
            products.forEach(product => product.dataset.active = product == closest.product);
            currentLook.floaterButtons.forEach((button, i) => button.classList.toggle("active", i == closest.index));


        }
        function getClosestOnScroll(list, products) {
            const maxScroll = list.scrollWidth - list.offsetWidth;

            // Handle edge cases
            if (list.scrollLeft < 20) {
                return { product: products[0], index: 0 };
            }
            if (list.scrollLeft > maxScroll - 20) {
                return { product: products[products.length - 1], index: products.length - 1 };
            }

            // Find closest to center
            let closestDistanceToCenter = Infinity;
            let closest = undefined;
            let index;

            const viewportCenter = list.scrollLeft + list.offsetWidth / 2;

            products.forEach((product, i) => {
                const productCenter = product.offsetLeft + product.offsetWidth / 2;
                const distance = Math.abs(viewportCenter - productCenter);

                if (distance < closestDistanceToCenter) {
                    closestDistanceToCenter = distance;
                    closest = product;
                    index = i;
                }
            });
            return { product: closest, index: index };
        }

        function setLookToProduct(index) {
            if (index >= currentLook.floaterButtons.length) index = currentLook.floaterButtons.length - 1;
            currentProductIndex = index;
            currentLook.floaterButtons.forEach((button, i) => button.classList.toggle("active", i == index));
            currentLook.list.style.setProperty("--show", index);
            updateIndicators();
            viewProductButton.href = looks[currentLookIndex].products[currentProductIndex].querySelector("a").href;

            if (touch()) {
                looks[currentLookIndex].products.forEach((product, i) => { product.dataset.active = i == currentProductIndex });
                looks[currentLookIndex].list.scrollTo(looks[currentLookIndex].products[0].offsetWidth * (currentProductIndex - .5), 0)
            }
        }
    });
}

function odfSetupReviews() {
    const sections = document.querySelectorAll("section.reviews");
    sections.forEach(section => {
        const
            list = section.querySelector(".reviews-list"),
            reviews = [...section.querySelectorAll(".buttons button")].map(d => { return { button: d, review: section.querySelector(`.review-item[data-id='${d.dataset.for}'`) } });
        reviews.forEach(reviewObj => reviewObj.button.addEventListener("click", () => click(reviewObj)));
        function click(targetReview) {
            if (window.innerWidth < 768) return;
            reviews.forEach(review => {
                review.button.dataset.active = review == targetReview
                review.review.dataset.active = review == targetReview
            });
            resize();
        }

        function resize() {
            if (window.innerWidth < 768) {
                list.style.height = "";
                mobileUpdate();
            }
            else
                list.style.height = `${reviews.find(d => d.review.dataset.active == "true").review.offsetHeight}px`;
        }

        function mobileUpdate() {
            const pos = Math.round(((list.scrollLeft + list.offsetWidth) / list.scrollWidth) * reviews.length) - 1;
            reviews.forEach(({ button }, i) => button.dataset.active = i == pos);
        }

        resize();
        window.addEventListener("load", resize);
        window.addEventListener("resize", resize);
        list.addEventListener("scroll", mobileUpdate);
    })
}

function setupCardFlickers() {
    const
        sections = document.querySelectorAll("section.flicker");

    sections.forEach(section => {
        const cards = section.querySelectorAll("li");

        setupFolderHint();

        window.addEventListener("resize", resize);
        window.addEventListener("DOMContentLoaded", resize);
        window.addEventListener("touchend", touchend);

        cards.forEach(card => {
            card.addEventListener("click", () => click(card))
            card.addEventListener("touchstart", () => touchstart(card))
        });

        function touchstart(card) {
            card.classList.add("hover");
        }
        function touchend() {
            cards.forEach(card => card.classList.remove("hover"));
        }

        function click(card) {
            const
                pos = parseInt(card.dataset.position),
                dif = pos - 1;

            if (dif === 0) return;
            for (i = 0; i < dif; i++) setTimeout(next, 200 * i);
        }


        function resize() {
            section.style.setProperty("--highest", getHighest());
        }

        function getHighest() {
            const highest = Array.from(cards).reduce((tallest, card) => card.offsetHeight > (tallest?.offsetHeight || 0) ? card : tallest, null);
            if (highest) return highest.offsetHeight + "px";
            return 0;
        }

        function next() {
            cards.forEach(card => {
                let pos = parseInt(card.dataset.position);
                pos -= 1;
                if (pos == -1) pos = 7;
                card.dataset.hidden = (pos > 4);
                card.dataset.position = pos;
            });
            setTimeout(resize, 500);
        }

        function setupFolderHint() {
            let hasHovered = false;
            cards.forEach(card => card.addEventListener("mouseenter", mouseenter));

            function mouseenter(e) {
                if (e.target.dataset.position != "1") hasHovered = true;
                cards.forEach(card => card.removeEventListener("mouseenter", mouseenter));
            }

            if (!window.IntersectionObserver) return;
            const options = {
                rootMargin: "0px 0px 0px 0px",
                threshold: 0.5,
            };
            let observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !hasHovered) setTimeout(() => {
                        giveHint();
                    }, 1500);
                });
            }, options);
            observer.observe(section);

            function giveHint() {
                observer.unobserve(section);

                if (hasHovered) return;
                addClassFor(section, "hint", 900);
            }
        }
    });
}

function addClassFor(el, className, time) {
    el.classList.add(className);
    setTimeout(() => el.classList.remove(className), time);
}

function setupChangeViewButtons() {
    const sections = document.querySelectorAll("section.shop");

    sections.forEach(section => {
        const
            buttons = section.querySelectorAll("button.change-view"),
            ul = section.querySelector("ul.products");
        buttons.forEach(button => button.addEventListener("click", () => click(button)));

        function click(button) {
            if (button.dataset.view == "6") addClassFor(ul, "animating", 250);
            ul.style.setProperty("--grid", button.dataset.view)
            ul.dataset.view = button.dataset.view;
            buttons.forEach(loopedButton => loopedButton.classList.toggle("active", loopedButton == button));
        }
    });
}

function addClassFor(el, className, time) {
    el.classList.add(className);
    setTimeout(() => el.classList.remove(className), time);
}

function setupAllCarrousels() {
    const carrousels = document.querySelectorAll("figure.carrousel");
    carrousels.forEach(figure => {
        const
            indicators = figure.querySelectorAll(".indicators button"),
            images = figure.querySelectorAll(":scope > ul > li"),
            arrows = figure.querySelectorAll(".arrow");
        let
            currentIndex = 0;

        window.addEventListener("keydown", keydown);
        arrows.forEach(arrow => {
            const dir = parseInt(arrow.dataset.dir);
            arrow.addEventListener("click", () => next(dir));
        });

        function next(dir) {
            currentIndex += dir;
            if (currentIndex < 0) currentIndex = images.length - 1;
            else if (currentIndex >= images.length) currentIndex = 0;
            setNewIndex();
        }

        indicators.forEach(indicator => indicator.addEventListener("click", () => {
            currentIndex = parseInt(indicator.dataset.for);
            setNewIndex();
        }));

        function setNewIndex() {
            [images, indicators].forEach(group => {
                group.forEach(item => item.dataset.active = parseInt(item.dataset.for) == currentIndex);
            });
        }

        function keydown(e) {
            if (e.key != "ArrowLeft" && e.key != "ArrowRight") return;
            if (figure.dataset.active == "false") return;
            next(e.key == "ArrowRight" ? 1 : -1);
        }
    });
}

function setupCollapsibleRows() {
    const
        rows = document.querySelectorAll(".collapsible-row"),
        openAccordion = accordion => {
            accordion.node.style.setProperty("--height", accordion.content.firstElementChild.offsetHeight + "px");
            accordion.button.ariaExpanded = true;
            accordion.content.ariaHidden = false;
        },
        closeAccordion = accordion => {
            accordion.node.style.setProperty("--height", accordion.content.firstElementChild.offsetHeight + "px");
            requestAnimationFrame(() => requestAnimationFrame(() => {
                accordion.node.style.setProperty("--height", "0");
                accordion.button.ariaExpanded = false;
                accordion.content.ariaHidden = true;
            }));
        },
        click = accordion => {
            accordion.otherRows.filter(d => d.button.ariaExpanded == "true").forEach(otherAccordion => closeAccordion(otherAccordion))
            accordion.button.ariaExpanded == "false" ? openAccordion(accordion) : closeAccordion(accordion)
        }

    rows.forEach(row => {
        const
            section = row.closest("section"),
            accordion = { otherRows: [...section.querySelectorAll(".collapsible-row")].map(d => ({ node: d, button: d.querySelector("button"), content: d.querySelector("div") })), node: row, button: row.querySelector("button"), content: row.querySelector("div") };
        accordion.button?.addEventListener("click", () => click(accordion))
        accordion.content?.addEventListener("transitionend", () => accordion.node.style.removeProperty("--height"));
    });
}

function setupActivateChildren() {
    const sections = document.querySelectorAll(".activate-children");
    sections.forEach(section => {
        const els = section.querySelectorAll(":scope > *");
        els.forEach((el, i) => {
            el.style.setProperty("--cascade", i);
        });
    });
}

function setupSort() {
    const btn = document.querySelector('[data-action="open-sort"]'),
        dropdown = document.getElementById('sort-dropdown');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', (e) => {
        e.stopPropagation();
        dropdown.classList.toggle('active');
    });

    dropdown.querySelectorAll('.sort-option').forEach(option => {
        option.addEventListener('click', () => {
            const url = new URL(window.location.href);
            if (option.dataset.sort === 'manual') {
                url.searchParams.delete('sort_by');
            } else {
                url.searchParams.set('sort_by', option.dataset.sort);
            }
            window.location.href = url.toString();
        });
    });

    document.addEventListener('click', (e) => {
        if (!btn.contains(e.target) && !dropdown.contains(e.target)) {
            dropdown.classList.remove('active');
        }
    });
}

function setupFilters() {
    const
        drawer = document.getElementById('filter-drawer'),
        form = document.getElementById('FacetFiltersForm');

    if (!drawer || !form) return;

    const
        open = () => { const sw = window.innerWidth - document.documentElement.clientWidth; document.body.style.paddingRight = sw + 'px'; drawer.classList.add('active'); document.body.style.overflow = 'hidden'; },
        close = () => { drawer.classList.remove('active'); document.body.style.overflow = ''; document.body.style.paddingRight = ''; };

    document.querySelectorAll('[data-action="open-filters"]').forEach(btn => btn.addEventListener('click', open));
    document.querySelectorAll('[data-action="close-filters"]').forEach(btn => btn.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('active')) close(); });
    document.querySelectorAll('[data-action="clear-filters"]').forEach(btn => {
        btn.addEventListener('click', () => {
            const url = new URL(window.location.href);
            url.search = '';
            window.location.href = url.toString();
        });
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const
            formData = new FormData(form),
            searchParams = new URLSearchParams(formData),
            url = new URL(window.location.href);

        url.search = searchParams.toString();

        try {
            const
                response = await fetch(url.toString()),
                html = await response.text(),
                doc = new DOMParser().parseFromString(html, 'text/html');

            document.querySelector('.products').innerHTML = doc.querySelector('.products').innerHTML;

            const
                newActiveFilters = doc.querySelector('.active-filters'),
                currentActiveFilters = document.querySelector('.active-filters'),
                buttonsDiv = document.querySelector('section.shop .buttons');

            if (currentActiveFilters) currentActiveFilters.remove();
            if (newActiveFilters) buttonsDiv.insertAdjacentElement('afterend', newActiveFilters);

            const
                newCount = doc.querySelector('.filter-count'),
                currentFilterBtn = document.querySelector('[data-action="open-filters"]'),
                currentCount = currentFilterBtn.querySelector('.filter-count');

            if (currentCount) currentCount.remove();
            if (newCount) currentFilterBtn.appendChild(newCount);

            window.history.pushState({}, '', url.toString());
            close();
        } catch (error) {
            console.error('Filter error:', error);
            window.location.href = url.toString();
        }
    });
}

function setupVariantPicker() {
    const pickers = document.querySelectorAll(".variant-picker");

    pickers.forEach(picker => {
        const
            form = document.querySelector("product-form .form"),
            variantInput = form?.querySelector("[data-variant-input]"),
            jsonScript = picker.querySelector("[data-variant-json]"),
            buttons = picker.querySelectorAll(".variant-picker__button"),
            selects = picker.querySelectorAll(".variant-picker__select");

        if (!form || !variantInput || !jsonScript) return;

        const variants = JSON.parse(jsonScript.textContent);

        buttons.forEach(button => button.addEventListener("click", () => {
            const position = button.dataset.optionPosition;
            picker.querySelectorAll(`.variant-picker__button[data-option-position="${position}"]`)
                .forEach(b => b.classList.toggle("active", b == button));
            update();
        }));

        selects.forEach(select => select.addEventListener("change", update));

        function getSelectedOptions() {
            const options = [];
            picker.querySelectorAll(".variant-picker__buttons").forEach(list => {
                const active = list.querySelector(".variant-picker__button.active");
                if (active) options[active.dataset.optionPosition - 1] = active.dataset.optionValue;
            });
            selects.forEach((select, index) => options[index] = select.value);
            return options;
        }

        function update() {
            const
                selected = getSelectedOptions(),
                variant = variants.find(v => selected.every((value, index) => v[`option${index + 1}`] == value));

            const
                submit = form.querySelector("[data-add-to-cart]"),
                skuEl = document.querySelector("[data-sku]");

            if (!variant) {
                variantInput.value = "";
                if (submit) submit.disabled = true;
                return;
            }

            variantInput.value = variant.id;
            // product.js owns the price so the sale price and the struck original
            // stay in sync; both pickers used to write [data-price] themselves.
            window.renderProductPrice?.(variant);
            if (skuEl) skuEl.textContent = variant.sku || "";
            if (submit) {
                submit.disabled = !variant.available;
                const label = submit.querySelector("span");
                if (label) label.textContent = variant.available
                    ? window.variantStrings?.addToCart || "Add to basket"
                    : window.variantStrings?.soldOut || "Sold out";
            }
        }
    });
}

function setupNewsletterKlaviyo() {
    const forms = document.querySelectorAll('form.newsletter-form[data-klaviyo-list]');
    forms.forEach(form => {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const listId = form.dataset.klaviyoList;
            const companyId = form.dataset.klaviyoCompany;
            const formData = new FormData(form);
            const email = formData.get('email');

            const profileAttributes = { email };
            const standardFields = { '$first_name': 'first_name', '$last_name': 'last_name', '$phone_number': 'phone_number' };

            for (const [key, value] of formData.entries()) {
                if (!value || key === 'email') continue;
                if (standardFields[key]) profileAttributes[standardFields[key]] = value;
            }

            const body = {
                data: {
                    type: 'subscription',
                    attributes: {
                        custom_source: 'Website form',
                        profile: { data: { type: 'profile', attributes: profileAttributes } }
                    },
                    relationships: { list: { data: { type: 'list', id: listId } } }
                }
            };

            const btn = form.querySelector('button');
            btn.disabled = true;
            btn.style.opacity = '.5';

            const showSuccess = () => {
                form.querySelector('.newsletter-fields').style.display = 'none';
                const msg = form.querySelector('.newsletter-success');
                msg.textContent = form.dataset.success;
                msg.style.display = '';
            };

            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
                body: JSON.stringify(body)
            }).then(showSuccess).catch(showSuccess);
        });
    });
}

function setupFAQ() {
    const faqs = document.querySelectorAll("ul.faq");
    faqs.forEach(faq => {
        const
            accordions = [...faq.querySelectorAll(":scope > li")].map(d => { return { node: d, button: d.querySelector("button"), content: d.querySelector("div") } }),
            openAccordion = accordion => {
                accordion.node.style.setProperty("--height", accordion.content.firstElementChild.offsetHeight + "px");
                accordion.button.ariaExpanded = true;
                accordion.content.ariaHidden = false;
            },
            closeAccordion = accordion => {
                accordion.node.style.setProperty("--height", accordion.content.firstElementChild.offsetHeight + "px");
                requestAnimationFrame(() => requestAnimationFrame(() => {
                    accordion.node.style.setProperty("--height", "0");
                    accordion.button.ariaExpanded = false;
                    accordion.content.ariaHidden = true;
                }));
            },
            click = accordion => {
                accordions.filter(d => d.button.ariaExpanded == "true").forEach(otherAccordion => closeAccordion(otherAccordion))
                accordion.button.ariaExpanded == "false" ? openAccordion(accordion) : closeAccordion(accordion)
            }

        accordions.forEach(accordion => {
            accordion.button?.addEventListener("click", () => click(accordion))
            accordion.content?.addEventListener("transitionend", () => accordion.node.style.removeProperty("--height"));
        });
    });
}

function loadFunction() {
    setTimeout(() => document.body.classList.remove("loading"), 125);
}


// -------------- CALLS --------------
setupAnchorAttributes();
scrollFunction();
loadFunction();

if (pageContains(".run-in-view")) setOnlyRunInViewObservers();
if (pageContains(".activate-children")) setupActivateChildren();
if (pageContains(".activate")) setOnlyRunInViewOnceObservers();
if (pageContains("section.filtered-collections")) setupFilteredSection();
if (pageContains("section.has-scrollbar")) setupFakeScrollbars();
if (pageContains("section.shop-the-look")) setupShowTheLook();
if (pageContains("section.reviews")) odfSetupReviews();
if (pageContains(".has-overflower.has-buttons")) setupOverflowerButtons();
if (pageContains("section.flicker")) setupCardFlickers();
if (pageContains("button.change-view")) setupChangeViewButtons();
if (pageContains("figure.carrousel")) setupAllCarrousels();
if (pageContains(".collapsible-row")) setupCollapsibleRows();
if (pageContains("ul.faq")) setupFAQ();
if (pageContains("#filter-drawer")) setupFilters();
if (pageContains("#sort-dropdown")) setupSort();
if (pageContains(".variant-picker")) setupVariantPicker();
if (pageContains('form.newsletter-form[data-klaviyo-list]')) setupNewsletterKlaviyo();